import { render, staticRenderFns } from "./GateRelatedLinks.vue?vue&type=template&id=0f5ba99e&"
import script from "./GateRelatedLinks.vue?vue&type=script&lang=js&"
export * from "./GateRelatedLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports